
import {
  Button,
  Paper,
  Grid,
  TextField,
  Select,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Typography,
  Tab,
  Tabs,
  Card,
  CardHeader,
  CardContent,
  Hidden,
  Divider,
  Tooltip,
  Chip,
  OutlinedInput,

} from "@material-ui/core";
import Box from '@material-ui/icons/AddBox';
import * as React from "react";
import { observable, action, computed, toJS, autorun } from "mobx";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { authStore } from "src/modules/auth";
import { usersAdminStore } from "..";
import { observer } from "mobx-react";
import { Loading } from "src/components/loading";
import { history } from "src/history.js";
import { withRouter } from "react-router";
import { validationsStore } from '../../../../validations';
import InfoIcon from '@material-ui/icons/Info';
import SelectChangeEvent from '@material-ui/core'
import { permissionsStore } from "../../Permissions"; // C-012
import { companiesAdminStore } from "src/modules/admin/modules/CompaniesAdmin"; // C-012
import './style.css'; // C-012

interface IAppInfo {
  app_id: number;
  App: string;
  AppRoles: any[]
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, personName: readonly string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const styles = createStyles({
  root: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    // padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
    overflow: 'hidden'
  },
  rowContainer: {
    width: "100%",
    display: "flex",
    alignContent: "center",
    margin: "0 auto",
    // padding: "3rem",
  },
  columnContainer: {
    width: "100%",
    display: "flex",
    margin: "0 auto",
    // padding: "3rem",
  },
  textField: {
    display: "flex",
    paddingRight: "24px",
  },
  roleSelect: {
    minWidth: "9rem",
  },
  companySelect: {
    minWidth: "16.5rem",
  },
  appRoleSelect: {
    minWidth: "16.5rem",
    paddingTop: "1.5rem",
  },
  formContainer: {
    width: "100%",
    padding: "1.5rem",
  },
  submitContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
  },
  submitButton: {
    backgroundColor: "#2A2A55",
    border: "1px solid #2D4D73",
    color: "#FAFAFA",
  },
  tabRoot: {
    height: '100%'
  },

});

@observer
class UserRoles extends React.Component<any> {

  // C-012
  public state = {
    university_role_id: [],
    current_tab: 0,
    siteSelectOpen: false,
    companySelectOpen: false,
  }

  constructor(props: any) {
    super(props);

  }

  @observable
  public isDistributorActive: boolean = false; // C-012.31

  @observable
  public showChatCardBox: boolean; // C-012.31

  // C-012
  public toggleAppAccess = (app: any) => {
    this.props.sendDataToParent(false)
    if (app.app_id === 1) {
      if (this.props.currentUser.portal_role_id != 7 && this.props.currentUser.portal_role_id != 8) { //D-011 new
        validationsStore.validator[
          "materialSelectSiteIDs"
        ].validateFunctions[0].active = !app.Active;
        validationsStore.runValidator(
          "materialSelectSiteIDs",
          this.props.currentUser.materialSelectSiteIDs
        );
      }
      validationsStore.validator[
        "pharmacyRole"
      ].validateFunctions[0].active = !app.Active;
      validationsStore.runValidator(
        "pharmacyRole",
        this.props.currentUser.Apps.find((a: any) => a.app_id === 1).roles
      );
      this.props.currentUser.materialSelectSiteIDs = []; // B-115.4
      this.props.currentUser.Apps[0].roles = []; // B-115.4
      
    } else if (app.app_id === 2) {
      validationsStore.validator[
        "universityRole"
      ].validateFunctions[0].active = !app.Active;
      validationsStore.runValidator(
        "universityRole",
        this.props.currentUser.Apps.find((a: any) => a.app_id === 2).roles
      );
      this.props.currentUser.Apps[1].roles = []; // B-115.4
    } else if (app.app_id === 3) {
      !app.Active ? this.showChatCardBox = true : this.showChatCardBox = false;
    }
    return usersAdminStore.toggleUserAppAccess(app);
  };

  // C-012
  public getCompanyChipInfo = (company_id: number) => {
    let company = companiesAdminStore.all_companies.find((c: any) => c.company_id === company_id)
    if (!company) {
      return 'none'
    }
    return (
      <React.Fragment>
        <b>{company.CompanyName}</b>
      </React.Fragment>
    )
  }

  // C-012
  public getSiteChipInfo = (site_id: number) => {
    const site = companiesAdminStore.all_sites.filter((s: any) => s.site_id === site_id)[0];
    if (!site) {
      return 'none'
    }
    return (
      <React.Fragment>
        <b>{site.displayName}</b> <span> ({site.CompanyName})</span>
      </React.Fragment>
    )
  }
  

  public togglePharmacyRole = (event: any) => {

    this.props.sendDataToParent(false)
    const fullPharmacyRole = this.props.allRoles.find((app: IAppInfo) => app.app_id === 1).AppRoles.filter((pharma_role: any) => pharma_role.pharmacy_role_id === event.target.value)
    validationsStore.runValidator('pharmacyRole', fullPharmacyRole)
    return usersAdminStore.togglePharmacyRole(fullPharmacyRole)
  }

  public toggleUniversityRole = (event: any, actionType: string) => {
    this.props.sendDataToParent(false, false)
    this.setState({ university_role_id: event.target.value });
    if (validationsStore.validator['universityRole'].validateFunctions[0].active === false) {
      validationsStore.validator['universityRole'].validateFunctions[0].active = true
    }
    let selectedId = event.target.value.map((item) => ({ university_role_id: item }))
    let data = this.props.allRoles.find((app: IAppInfo) => app.app_id === 2).AppRoles;
    let result = selectedId.map((item) => {
      let obj = data.find((o) => o.university_role_id === item.university_role_id);
      return { ...obj, ...item }
    })
    return usersAdminStore.toggleUniversityRole(result, actionType)
  }

  public universityRoleDisabled = (role: string) => {
    this.props.sendDataToParent(false)
    if (this.props.match.params.view_type === 'detail') {
      return true;
    }
    role === 'Student' ? true : false;
  }

  @action
  public toggleSkipCourses = () => {
    this.props.sendDataToParent(false)
    const val = this.props.currentUser.IntroCoursesComplete === 0 ? 1 : 0;
    this.props.currentUser.IntroCoursesComplete = val;
  }

  @action
  public toggleSkipPharmacyCourses = () => {
    this.props.sendDataToParent(false)
    const val = this.props.currentUser.PharmacyQualified === 0 ? 1 : 0;
    this.props.currentUser.PharmacyQualified = val;
  }

  componentDidMount() {
    let dataValue = this.props.currentUser.Apps[1].roles.map((role: any, index: number) => {
      return role.university_role_id;
    })
    this.setState({ university_role_id: dataValue });
  }

  componentDidUpdate() {
    if (this.props.currentUser.portal_role_id === 7 || this.props.currentUser.portal_role_id === 8) {
      this.isDistributorActive = false
    }
    if (this.props.currentUser.Apps[2].Active === false) {
      this.showChatCardBox = false
    }
  }


  public getAppCard(appObj: any) {
      {/* C-012 */}
    const app_id = appObj.app_id;
    const { currentUser, classes } = this.props;

    const userAppInfo = currentUser.Apps.find((app: any) => app.app_id === app_id);
    const selected = userAppInfo.roles[0] || { pharmacy_role_id: 0 };
    const selected1 = currentUser.Apps?.filter((a: any) => a.app_id === app_id)[0].roles?.filter((app_role: any) => app_role.role_id === this.state.university_role_id).length > 0

    let dataValue = this.props.currentUser.Apps[1].roles.map((role: any, index: number) => {
      return role.university_role_id;
    })

    let univ_role_id = dataValue;

    return (
      <>
        {(userAppInfo.Active && app_id == 1) && (
          <Card className="rolescard">
            <CardHeader title='Pharmacy' />
            <CardContent>
              <FormControl error={!validationsStore.validator['pharmacyRole'].valid}>
                <InputLabel htmlFor={"user_role"} shrink={true}>
                  User Role
                </InputLabel>
                <Select
                  inputProps={{ name: "user_role", id: "user_role" }}
                  value={selected.pharmacy_role_id || 0}
                  classes={{ root: classes.roleSelect }}
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={this.togglePharmacyRole}
                  disabled={this.props.match.params.view_type === 'detail'}
                >
                  {appObj.AppRoles.filter((role: any) => ((role.priority) + 1) >= authStore.currentUser.portal_role_id)?.sort((a, b) => a.priority - b.priority)?.map((role: any, index: number) => { // C-010                                    
                    return (
                      <MenuItem key={index} value={role.pharmacy_role_id}>
                        {role?.PharmacyRoleName?.charAt(0).toUpperCase() + role?.PharmacyRoleName?.slice(1)}
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>
                  {!validationsStore.validator["pharmacyRole"].valid
                    ? validationsStore.validator["pharmacyRole"].errorMessage.join()
                    : " "}
                </FormHelperText>
              </FormControl>
              {/* <Divider /> */}
              {this.props.match.params.view_type === "create" ?
                <React.Fragment>
                  <div style={{ display: 'block', float: 'left' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={this.props.match.params.view_type === 'detail'}
                          style={{ marginLeft: '5px' }}
                          checked={this.props.currentUser.PharmacyQualified === 1}
                          // tslint:disable-next-line: jsx-no-lambda
                          onChange={() => this.toggleSkipPharmacyCourses()}
                        // color="primary"
                        />
                      }
                      label={'Skip Intro Courses'}
                    />
                  </div>
                  <div style={{ display: 'block', float: 'right', marginTop: '10px' }}>
                    <Tooltip
                      style={{ display: this.props.match.params.view_type !== 'create' ? 'none' : '' }}
                      title={'Allow this user to access Pharmacy app without needing to complete the introductory courses'}
                    >
                      <InfoIcon />
                    </Tooltip>
                  </div>
                </React.Fragment>
                :
                null
              }

            </CardContent>
          </Card>
        )}

        {(userAppInfo.Active && app_id === 2) && (
          <Card className="rolescard">
            <CardHeader title='University' />
            <CardContent>
              <div className={classes.root}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-multiple-chip-label">
                    User Role
                  </InputLabel>
                  <Select
                    id="demo-multiple-chip"
                    multiple
                    value={this.props.toggleCancle === false ? this.state?.university_role_id : univ_role_id}
                    // value={this.state.university_role_id}
                    onChange={(e) => this.toggleUniversityRole(e, selected1 ? 'drop' : 'add')}
                    MenuProps={MenuProps}
                  >
                    {(appObj.AppRoles || []).map((role: any, index: number) => (
                      <MenuItem
                        key={index}
                        value={role.university_role_id}
                      >
                        {role.UniversityRoleName}
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>
              </div>
              <Divider />
              <div style={{ display: 'block', float: 'left' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={this.props.match.params.view_type === 'detail'}
                      style={{ marginLeft: '5px' }}
                      checked={this.props.currentUser.IntroCoursesComplete === 1}
                      // tslint:disable-next-line: jsx-no-lambda
                      onChange={() => this.toggleSkipCourses()}
                    // color="primary"
                    />
                  }
                  label={'Skip Intro Courses'}
                />
              </div>
              <div style={{ display: 'block', float: 'right', marginTop: '10px' }}>
                <Tooltip
                  title={'Allow this user to access full University app without needing to complete the introductory courses'}
                >
                  <InfoIcon />
                </Tooltip>
              </div>
            </CardContent>
          </Card>
        )}
      </>

    )
  }

  // C-012
  public getAppAccessBoxes = () => {
    return (
      this.props.currentUser.Apps.map((app: any) => {
        return (
          <div key={app.app_id}>
            <FormControlLabel
              key={app.app_id}
              control={
                <Checkbox
                  checked={app.Active}
                  disabled={this.props.match.params.view_type === 'detail'}
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={() => this.toggleAppAccess(app)}
                />
              }
              label={`Access to ${app.App}?`}
            />
          </div>
        )
      })
    )
  }

  public render() {
    const { classes, mode, allRoles, currentUser } = this.props;

    //D-011 C-012
    let sortedSitesValue = companiesAdminStore.all_sites.sort((a, b) => {
      const nameA = a.displayName.toUpperCase();
      const nameB = b.displayName.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    {/* C-012 */}
    let allCompanyData: any;
    if ((authStore.currentUser.portal_role_id == 7 || authStore.currentUser.portal_role_id == 8 || this.props.currentUser.portal_role_id == 7 || this.props.currentUser.portal_role_id == 8)) {
      allCompanyData = companiesAdminStore.all_companies.filter((item) => item.CompanyBusinessType != null) //D-011 new
    } else {
      allCompanyData = companiesAdminStore.all_companies; //D-011 new
    }
    allCompanyData = allCompanyData.sort((a, b) => {
      const nameA = a.CompanyName.toUpperCase();
      const nameB = b.CompanyName.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    
    // C-012
    let allPortalRolesPermissionsStore = permissionsStore.allPortalRoles;
    if (authStore.currentUser.portal_role_id == 4 || authStore.currentUser.portal_role_id == 5 || authStore.currentUser.portal_role_id == 6) {
      allPortalRolesPermissionsStore = allPortalRolesPermissionsStore.filter(item => (
        (item.portal_role_id !== 7 && item.portal_role_id !== 8)
      ))
    }

    if (
      !this.props.currentUser
    ) {
      return <Loading />;
    } else {
      return (
        <div className={classes.root}>
          <div className="rolescontainer-scroller cstm-rolescontainer-scroller">
            <Grid container={true} spacing={8}>
              {/*  C-012 */}
              <Grid item xs={12} lg={10}>
                <Paper className={classes.paper}>
                  <CardHeader title="The MedPortal" />
                  <CardContent className="themedportal-container">
                    <div className="themedportal-form">
                      {this.getAppAccessBoxes()}
                    </div>
                    <div style={{ flexGrow: 1 }}>
                      <div className="checkbox-container">
                        {allRoles.map((app: any) => {
                          return (
                            <Grid item={true} xs={4} key={app.app_id}>
                              {this.getAppCard(app)}
                            </Grid>
                          );
                        })}
                        {(this.isDistributorActive ||
                          this.props.currentUser["portal_role_id"] == 7 ||
                          this.props.currentUser["portal_role_id"] == 8) && (
                          <Grid xs={4}>
                            <Card className="rolescard">
                              <CardHeader title="Distributor" />
                              <CardContent>
                                <FormControl //D-011 all FormControl
                                  error={
                                    !validationsStore.validator[
                                      "materialSelectDistributorIDs"
                                    ].valid
                                  }
                                >
                                  <InputLabel
                                    htmlFor={"user_distributor"}
                                    shrink={true}
                                  >
                                    Distributor
                                  </InputLabel>
                                  <Select
                                    inputProps={{
                                      name: "distributor",
                                      id: "id",
                                    }}
                                    value={
                                      this.props.currentUser
                                        .materialSelectDistributorIDs || 0
                                    }
                                    classes={{ root: classes.roleSelect }}
                                    // tslint:disable-next-line: jsx-no-lambda
                                    onChange={this.handleInput(
                                      "materialSelectDistributorIDs"
                                    )}
                                    disabled={
                                      this.props.match.params.view_type ===
                                      "detail"
                                    }
                                  >
                                    {this.props.currentUser["portal_role_id"] ==
                                      7 ||
                                    this.props.currentUser["portal_role_id"] ==
                                      8
                                      ? companiesAdminStore?.all_distributor?.map(
                                          (distributor: any, index: number) => {
                                            return (
                                              <MenuItem
                                                key={index}
                                                value={distributor.id}
                                              >
                                                {distributor.distributor}
                                              </MenuItem>
                                            );
                                          }
                                        )
                                      : ""}
                                  </Select>
                                  <FormHelperText>
                                    {!validationsStore.validator[
                                      "materialSelectDistributorIDs"
                                    ].valid
                                      ? validationsStore.validator[
                                          "materialSelectDistributorIDs"
                                        ].errorMessage.join()
                                      : " "}
                                  </FormHelperText>
                                </FormControl>
                              </CardContent>
                            </Card>
                          </Grid>
                        )}
                      </div>
                    </div>
                  </CardContent>
                </Paper>
              </Grid>
              {/* // B-115.4 */}
              <Grid item xs={4} lg={2}>
                <Paper className={classes.paper}>
                  <Card className="rolescard">
                    <CardContent>
                      <FormControl
                        error={
                          !validationsStore.validator["portal_role_id"].valid
                        }
                      >
                        <div style={{ marginTop: "20px", display: "grid" }}>
                          <InputLabel htmlFor={"portal_role"} shrink={true}>
                            The MedPortal
                          </InputLabel>
                          <Select
                            inputProps={{
                              name: "portal_role",
                              id: "portal_role",
                            }}
                            value={this.props.currentUser.portal_role_id || 0}
                            classes={{ root: classes.roleSelect }}
                            onChange={this.handleInput("portal_role_id")}
                            disabled={
                              this.props.match.params.view_type === "detail"
                            }
                          >
                            {allPortalRolesPermissionsStore
                              .filter(
                                (role: any) =>
                                  role.portal_role_id >=
                                  authStore.currentUser.portal_role_id
                              )
                              .map((role: any, index: number) => {
                                //D-011
                                return (
                                  <MenuItem
                                    key={index}
                                    value={role.portal_role_id}
                                  >
                                    {role.PortalRoleName}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText>
                            {!validationsStore.validator["portal_role_id"].valid
                              ? validationsStore.validator[
                                  "portal_role_id"
                                ].errorMessage.join()
                              : " "}
                          </FormHelperText>
                        </div>
                        {(this.showChatCardBox ||
                          this.props.currentUser.Apps[2].Active) && (
                          <div>
                            <CardHeader title="Chat" />
                            <div className={classes.root}>
                              {allRoles[2]?.AppRoles.map((role: any) => {
                                return (
                                  <div key={role.role_id}>{role.RoleName}</div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </FormControl>
                    </CardContent>
                  </Card>
                </Paper>
              </Grid>
              {/* // B-115.4 */}
              {this.props.currentUser.Apps[0].Active && (
                <Grid item xs={8} lg={6} className="roles-container">
                  <Paper className={classes.paper}>
                    <CardHeader title="Pharmacies" />
                    <CardContent className="rolescontainer-edit">
                      <FormControl
                        error={
                          this.props.currentUser.materialSelectSiteIDs
                            .length === 0
                            ? !validationsStore.validator[
                                "materialSelectSiteIDs"
                              ].valid
                            : false
                        }
                      >
                        <div className="rolescontainer-list cstmRolescontainer-list">
                          <Select
                            multiple={true}
                            inputProps={{ name: "user_site", id: "user_site" }}
                            value={this.props.currentUser.materialSelectSiteIDs}
                            classes={{ root: classes.companySelect }}
                            onChange={this.handleInput("materialSelectSiteIDs")}
                            disabled={
                              this.props.match.params.view_type === "detail"
                            }
                            // tslint:disable-next-line: jsx-no-lambda
                            renderValue={(selected: any) => {
                              let all_sitesItemLista =
                                companiesAdminStore.all_sites.filter((c: any) =>
                                  selected.includes(c.site_id)
                                );
                              let selectedCompany = all_sitesItemLista.sort(
                                (a, b) => {
                                  const nameA = a.displayName.toUpperCase();
                                  const nameB = b.displayName.toUpperCase();
                                  if (nameA < nameB) {
                                    return -1;
                                  }
                                  if (nameA > nameB) {
                                    return 1;
                                  }
                                  return 0;
                                }
                              );
                              selected = [];
                              selectedCompany.map((Pharmacies: any) => {
                                selected.push(Pharmacies.site_id);
                              });

                              if (
                                this.props.match.params.view_type === "detail"
                              ) {
                                return (
                                  <div style={{ whiteSpace: "normal" }}>
                                    {selected.map((c: any) => (
                                      <Chip
                                        style={{ marginTop: "3px" }}
                                        key={c}
                                        label={this.getSiteChipInfo(c)}
                                        className={classes.chip}
                                      />
                                    ))}
                                  </div>
                                );
                              }
                              return (
                                <div style={{ whiteSpace: "normal" }}>
                                  {selected.map((c: any) => (
                                    <Chip
                                      style={{ marginTop: "3px" }}
                                      key={c}
                                      label={this.getSiteChipInfo(c)}
                                      className={classes.chip}
                                      onDelete={() => {
                                        if (document.activeElement) {
                                          (
                                            document.activeElement as HTMLElement
                                          ).blur();
                                        }
                                        this.dropSite(c);
                                      }}
                                    />
                                  ))}
                                </div>
                              );
                            }}
                          >
                            {/* C-042 */}
                            {sortedSitesValue
                              .filter((site: any) =>
                                this.props.currentUser.materialSelectCompanyIDs.includes(
                                  site.company_id
                                )
                              ) //MuiToolbar-gutters-161
                              .map((site: any, index: number) => {
                                return (
                                  <MenuItem key={index} value={site.site_id}>
                                    {
                                      <React.Fragment>
                                        <span style={{ fontWeight: "bold", marginRight: '4px' }}>
                                          {site.displayName}
                                        </span>
                                        <span style={{ fontSize: "12px" }}>
                                          {" "}
                                          ({site.CompanyName})
                                        </span>
                                      </React.Fragment>
                                    }
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </div>
                        {this.props.currentUser.materialSelectSiteIDs.length ===
                        0 ? (
                          <FormHelperText>
                            {!validationsStore.validator[
                              "materialSelectSiteIDs"
                            ].valid
                              ? validationsStore.validator[
                                  "materialSelectSiteIDs"
                                ].errorMessage.join()
                              : " "}
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </FormControl>
                    </CardContent>
                  </Paper>
                </Grid>
              )}
               {/* // B-115.4 */}
              {this.props.currentUser.portal_role_id && (
                <Grid item xs={12} lg={6} className="roles-container">
                  <Paper className={classes.paper}>
                    <CardHeader title="Company" />
                    <CardContent className="rolescontainer-edit">
                      <FormControl
                        error={
                          this.props.currentUser.materialSelectCompanyIDs
                            .length === 0
                            ? !validationsStore.validator[
                                "materialSelectCompanyIDs"
                              ].valid
                            : false
                        }
                      >
                        <div className="rolescontainer-list cstmRolescontainer-list">
                          <Select
                            multiple={true}
                            inputProps={{
                              name: "user_company",
                              id: "user_company",
                            }}
                            value={
                              this.props.currentUser.materialSelectCompanyIDs
                            }
                            classes={{ root: classes.companySelect }}
                            onChange={this.handleInput(
                              "materialSelectCompanyIDs"
                            )}
                            disabled={
                              this.props.match.params.view_type === "detail"
                            }
                            renderValue={(selected: any) => {
                              let companies =
                                companiesAdminStore.all_companies.filter(
                                  (c: any) => selected.includes(c.company_id)
                                );
                              let selectedCompany = companies.sort((a, b) => {
                                const nameA = a.CompanyName.toUpperCase();
                                const nameB = b.CompanyName.toUpperCase();
                                if (nameA < nameB) {
                                  return -1;
                                }
                                if (nameA > nameB) {
                                  return 1;
                                }
                                return 0;
                              });

                              selected = [];
                              selectedCompany.map((company: any) => {
                                selected.push(company.company_id);
                              });

                              if (
                                this.props.match.params.view_type === "detail"
                              ) {
                                return (
                                  <div style={{ whiteSpace: "normal" }}>
                                    {selected?.map((c: any) => (
                                      <Chip
                                        style={{ marginTop: "3px" }}
                                        key={c}
                                        label={this.getCompanyChipInfo(c)}
                                        className={classes.chip}
                                      />
                                    ))}
                                  </div>
                                );
                              }
                              return (
                                <div style={{ whiteSpace: "normal" }}>
                                  {selected?.map((c: any) => (
                                    <Chip
                                      style={{ marginTop: "3px" }}
                                      key={c}
                                      label={this.getCompanyChipInfo(c)}
                                      className={classes.chip}
                                      onDelete={() => {
                                        if (document.activeElement) {
                                          (
                                            document.activeElement as HTMLElement
                                          ).blur();
                                        }
                                        this.dropCompany(c);
                                      }}
                                    />
                                  ))}
                                </div>
                              );
                            }}
                          >
                            {this.props.currentUser["portal_role_id"]
                              ? allCompanyData
                                  .filter(
                                    (companie: any) =>
                                      companie.PortalDeletedAt === null
                                  ) // B-014 D-011
                                  .map((company: any, index: number) => {
                                    return (
                                      <MenuItem
                                        key={index}
                                        value={company.company_id}
                                      >
                                        {company.CompanyName}
                                      </MenuItem>
                                    );
                                  })
                              : ""}
                          </Select>
                        </div>
                        {this.props.currentUser.materialSelectCompanyIDs
                          .length === 0 ? (
                          <FormHelperText>
                            {!validationsStore.validator[
                              "materialSelectCompanyIDs"
                            ].valid
                              ? validationsStore.validator[
                                  "materialSelectCompanyIDs"
                                ].errorMessage.join()
                              : " "}
                          </FormHelperText>
                        ) : (
                          ""
                        )}
                      </FormControl>
                    </CardContent>
                  </Paper>
                </Grid>
              )}
            </Grid>
          </div>
        </div>
      );
    }
  }

  // C-012

  @action
  public dropSite = (site_id: number) => {
    this.props.sendDataToParent(false)
    this.props.currentUser.materialSelectSiteIDs = this.props.currentUser.materialSelectSiteIDs.filter((s: any) => s !== site_id);
    validationsStore.runValidator('materialSelectSiteIDs', this.props.currentUser.materialSelectSiteIDs)
  };

  @action
  public dropCompany = (company_id: number) => {
    this.props.sendDataToParent(false)
    this.props.currentUser.materialSelectCompanyIDs = this.props.currentUser.materialSelectCompanyIDs.filter((c: any) => c !== company_id);
    validationsStore.runValidator('materialSelectCompanyIDs', this.props.currentUser.materialSelectCompanyIDs)
  };

  @action
  protected handleInput = (property: string) => (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    this.props.sendDataToParent(false)
    this.setState({ siteSelectOpen: false, companySelectOpen: false })
    this.props.currentUser[property] = e.target.value;
    //C-0.12
    if (this.props.currentUser[property] === 7 || this.props.currentUser[property] === 8) {
      this.isDistributorActive = true;
    } else if (e.target.name === "distributor") {
      this.isDistributorActive = true;
    } else {
      this.isDistributorActive = false;
    }

    validationsStore.runValidator(property, this.props.currentUser[property] = e.target.value)
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(UserRoles)
);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/components/UsersRoles.tsx